import React, { Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Box, Tabs } from 'stylist'
import withUser from 'components/withUser'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import RelationshipContainer from 'components/RelationshipContainer'
import fields from 'fields/users'
import RouteUserCompanies from 'routes/admin/users/companies'
import RouteUserCompaniesNew from 'routes/admin/users/companies/new'
import RouteUserCompaniesManage from 'routes/admin/users/companies/manage'
import RouteUserProducts from 'routes/admin/users/products'
import RouteUserServers from 'routes/admin/users/servers'
import RouteServersManage from 'routes/admin/users/servers/manage'
import renderValue from 'utils/renderValue'

const RouteShow = ({ user, match: { path } }) => (
  <Fragment>
    <h5>User Information</h5>
    <Box>
      <Box.Item pad>
        {fields.map(field => (
          <InfoGroup key={field.name}>
            <Subheader>{field.label || field.name}:</Subheader>
            <span>{renderValue(user[field.name])}</span>
          </InfoGroup>
        ))}
      </Box.Item>
    </Box>
    <Tabs>
      <Tabs.Item to={`${path}/companies`}>Companies</Tabs.Item>
      <Tabs.Item to={`${path}/servers`}>Servers</Tabs.Item>
      <Tabs.Item to={`${path}/products`}>Products</Tabs.Item>
    </Tabs>
    <RelationshipContainer>
      <Switch>
        <Route
          path={`${path}/companies`}
          exact
          render={routeProps => (
            <RouteUserCompanies
              variables={{ user_id: user.id }}
              {...routeProps}
            />
          )}
        />
        <Route
          path={`${path}/companies/new`}
          exact
          render={routeProps => (
            <RouteUserCompaniesNew user={user} {...routeProps} />
          )}
        />
        <Route
          path={`${path}/companies/manage`}
          exact
          render={routeProps => (
            <RouteUserCompaniesManage
              user={user}
              variables={{ user_id: user.id, show_has_user: true }}
            />
          )}
        />
        <Route
          path={`${path}/servers`}
          exact
          render={routeProps => (
            <RouteUserServers
              variables={{ user_id: user.id }}
              {...routeProps}
            />
          )}
        />
        <Route
          path={`${path}/servers/manage`}
          exact
          render={() => (
            <RouteServersManage
              user={user}
              variables={{ user_id: user.id, show_has_user: true }}
            />
          )}
        />
        <Route
          path={`${path}/products`}
          exact
          render={routeProps => (
            <RouteUserProducts
              variables={{ user_id: user.id }}
              {...routeProps}
            />
          )}
        />
      </Switch>
    </RelationshipContainer>
  </Fragment>
)

export default withUser(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/users/show.js